"use client";

import { createContext, useContext } from "react";

/** Active screen headings sit below the page heading in the landing display. */
export const FormFunnelHeadingContext = createContext<"h1" | "h2">("h1");

export function useFormFunnelHeadingLevel() {
  return useContext(FormFunnelHeadingContext);
}
